export default __webpack_public_path__ + "static/media/RARE_GUYS_PAGE.42fea45f.png";